module.exports = __webpack_public_path__ + "static/img/多维度客户分析.0c6ac80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/多维度客户分析.png
// module id = I9kl
// module chunks = 0